import { ArticleCommentsTopTabRenderProps } from "./articleCommentsTopTabWrapper"
import { getTranslation } from "./translations"
require("./magazine_magazine2025_yplus_ynet_site_premiumArticleCommentsTopTabUI.less")

interface PremiumArticleCommentsTopTabUIProps {
    props: ArticleCommentsTopTabRenderProps
}

export class PremiumArticleCommentsTopTabUI extends React.Component<PremiumArticleCommentsTopTabUIProps, {}>{
    private handleOnAddCommentBtnPress = (e) => {
        const { handleFormVisibility } = this.props.props
        handleFormVisibility()
    }

    render() {
        const { lang, isLtr, numOfComments, numOfDiscussions, sortSelection, areAllCommentsExpanded, isAddCommentFormVisible,
            expandAllComments, handleFormVisibility, handleSortSelection } = this.props.props
        let commentNumStyle = isLtr ? { marginRight: "5px" } : {}

        return (
            <div className="PremiumArticleCommentsTopTabUI">
                <div className="tab">
                    {numOfComments === 1 &&
                        <div className="tabTextWraper">
                            <span>{getTranslation(lang, "This Article Has One Comment")}</span>
                        </div>}

                    {numOfComments !== 1 &&
                        <div className="tabTextWraper">
                            <span>{getTranslation(lang, "This Article Has ")} </span>
                            <span style={commentNumStyle}>{` ${numOfComments} `} </span>
                        <span>{`${getTranslation(lang, "Comments In")}- `}</span>
                            <span>{!isLtr && `${numOfDiscussions} `}</span>
                            <span>{!isLtr && getTranslation(lang, "Discussions")}</span>
                        </div>}


                    {numOfComments > 0 &&
                        <div className="sortOptions">
                            <span className="selectLabel">{`${getTranslation(lang, "Sort Comments By")}`}</span>
                            <div className="togglerWrapper"  >
                                <div className="toggler" />
                            </div>
                            <select className="sortSelect" defaultValue={sortSelection} onChange={handleSortSelection}>
                                <option value="end_to_start">{getTranslation(lang, "End To Start")}</option>
                                {numOfComments > 1 && <option value="start_to_end">{getTranslation(lang, "Start To End")}</option>}
                                {numOfComments > 2 && <option value="recommended">{getTranslation(lang, "Recommended")}</option>}
                                {numOfComments > 2 && <option value="interest">{getTranslation(lang, "Interest")}</option>}
                            </select>
                        </div>}
                </div>

                <div className="topPanel">
                    <button
                        key="newCommentBtn"
                        className="newCommentBtn"
                        title={getTranslation(lang, "New Comment")}
                        disabled={isAddCommentFormVisible}
                        onClick={this.handleOnAddCommentBtnPress}>
                        <span>{getTranslation(lang, "New Comment(premium)")}</span>
                    </button>
                </div>
            </div >
        )
    }
}